/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateTriggerConditionRequestDto
 */
export interface CreateTriggerConditionRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTriggerConditionRequestDto
     */
    conditionType: CreateTriggerConditionRequestDtoConditionTypeEnum;
    /**
     * Interval magnitude
     * @type {number}
     * @memberof CreateTriggerConditionRequestDto
     */
    intervalValue: number;
    /**
     * TIME: DAY/WEEK/MONTH/YEAR only. METER: SESSION/KWH/HOUR only (meter semantics derived from unit).
     * @type {string}
     * @memberof CreateTriggerConditionRequestDto
     */
    intervalUnit: CreateTriggerConditionRequestDtoIntervalUnitEnum;
}


/**
 * @export
 */
export const CreateTriggerConditionRequestDtoConditionTypeEnum = {
    Time: 'TIME',
    Meter: 'METER'
} as const;
export type CreateTriggerConditionRequestDtoConditionTypeEnum = typeof CreateTriggerConditionRequestDtoConditionTypeEnum[keyof typeof CreateTriggerConditionRequestDtoConditionTypeEnum];

/**
 * @export
 */
export const CreateTriggerConditionRequestDtoIntervalUnitEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR',
    Session: 'SESSION',
    Kwh: 'KWH',
    Hour: 'HOUR'
} as const;
export type CreateTriggerConditionRequestDtoIntervalUnitEnum = typeof CreateTriggerConditionRequestDtoIntervalUnitEnum[keyof typeof CreateTriggerConditionRequestDtoIntervalUnitEnum];


/**
 * Check if a given object implements the CreateTriggerConditionRequestDto interface.
 */
export function instanceOfCreateTriggerConditionRequestDto(value: object): value is CreateTriggerConditionRequestDto {
    if (!('conditionType' in value) || value['conditionType'] === undefined) return false;
    if (!('intervalValue' in value) || value['intervalValue'] === undefined) return false;
    if (!('intervalUnit' in value) || value['intervalUnit'] === undefined) return false;
    return true;
}

export function CreateTriggerConditionRequestDtoFromJSON(json: any): CreateTriggerConditionRequestDto {
    return CreateTriggerConditionRequestDtoFromJSONTyped(json, false);
}

export function CreateTriggerConditionRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTriggerConditionRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'conditionType': json['conditionType'],
        'intervalValue': json['intervalValue'],
        'intervalUnit': json['intervalUnit'],
    };
}

export function CreateTriggerConditionRequestDtoToJSON(json: any): CreateTriggerConditionRequestDto {
    return CreateTriggerConditionRequestDtoToJSONTyped(json, false);
}

export function CreateTriggerConditionRequestDtoToJSONTyped(value?: CreateTriggerConditionRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conditionType': value['conditionType'],
        'intervalValue': value['intervalValue'],
        'intervalUnit': value['intervalUnit'],
    };
}

